export enum InvoiceStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void',
}

export interface Invoice {
  id: number
  status: InvoiceStatus
  displayAmount: string
  createdAt: string
  currency: string
}

export interface InvoicePreview {
  total: number
  totalExcludingTax: number
  tax: number
  taxPercent: number
}
